var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_405_41",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0H2.09524C0.93807 0 0 0.955126 0 2.13333V13.8667C0 15.0449 0.93807 16 2.09524 16H19.9048C21.0619 16 22 15.0449 22 13.8667V2.13333C22 0.955126 21.0619 0 19.9048 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_405_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0H2.09524C0.93807 0 0 0.955126 0 2.13333V13.8667C0 15.0449 0.93807 16 2.09524 16H19.9048C21.0619 16 22 15.0449 22 13.8667V2.13333C22 0.955126 21.0619 0 19.9048 0Z",
    fill: "#E70B17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6688 9.2288L13.4514 9.87946L13.684 8.50026L12.6992 7.52213L14.0611 7.31946L14.6688 6.06506L15.2764 7.32053L16.6383 7.5232L15.6535 8.4992L15.8861 9.8784",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95238 11.7333C11.9774 11.7333 13.619 10.0619 13.619 8C13.619 5.93813 11.9774 4.26666 9.95238 4.26666C7.92733 4.26666 6.28571 5.93813 6.28571 8C6.28571 10.0619 7.92733 11.7333 9.95238 11.7333ZM11 10.6667C12.4457 10.6667 13.619 9.472 13.619 8C13.619 6.528 12.4457 5.33333 11 5.33333C9.55428 5.33333 8.38095 6.528 8.38095 8C8.38095 9.472 9.55428 10.6667 11 10.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0.53334H2.09524C1.22736 0.53334 0.523811 1.24968 0.523811 2.13334V13.8667C0.523811 14.7503 1.22736 15.4667 2.09524 15.4667H19.9048C20.7726 15.4667 21.4762 14.7503 21.4762 13.8667V2.13334C21.4762 1.24968 20.7726 0.53334 19.9048 0.53334Z",
    stroke: "black",
    strokeOpacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/TR.6ee6d6e2d859df6d55aadb813f839dcb.svg";
export { ForwardRef as ReactComponent };